import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/gruh-udhyog/stock-entries";

export const Route = createFileRoute(
  "/admin/_modules/_gruh-udhyog/stock-entries"
)({
  component: Page,
});
